<template>
  <div class="feedback-container">
    <!-- 标题 -->
    
    <!-- 切换标签 -->
    <div class="tab-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="新产品需求" name="demand">
          <DemandForm 
            v-if="activeTab === 'demand'" 
            :form-data="demandFormData"
            @submit-success="onSubmitSuccess"
          />
        </el-tab-pane>
        <el-tab-pane label="建议反馈" name="suggestion">
          <div class="suggestion-form-container" v-if="activeTab === 'suggestion'">
            <div class="form-header">
              <!-- <h2 class="he-title">产品质量优化</h2> -->
              <p class="he-title">如果您对我们的<span class="highlight">服务、产品优化、产品价格</span>等方面有更好的建议，请详细告诉我们，谢谢!</p>
            </div>
            <el-form  :model="suggestionForm" label-width="60px" class="suggestion-form">
              
               <el-form-item label="建议">
                    <el-input 
                      v-model="suggestionForm.parts_cri" 
                      type="textarea" 
                      :rows="6" 
                      placeholder="请详细描述您的建议"
                      class="custom-textarea"
                    ></el-input>
                  </el-form-item>
              <!-- 图片上传 -->
              <el-form-item label="图片">
                <el-upload
                 
                  :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                  :data="{store_id:this.$store.state.store_id}"
                  :headers="{'token':$store.state.token}"
                  name="image"
                  list-type="picture-card"
                  :on-success="upImgSuccess"
                  :limit="9"
                  :on-remove="(file)=>{fileDel(file,'imgList')}"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              
              <!-- 文件上传 -->
              <el-form-item label="附件">
                <el-upload
                  :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                  :data="{store_id:this.$store.state.store_id}"
                  :headers="{'token':$store.state.token}"
                  name="image"
                  :on-success="upFileSuccess"
                  :limit="9"
                  :on-remove="(file)=>{fileDel(file,'fileList')}"
                  multiple
                >
                  <div 
                    style="width: 80px; height: 28px; background-color: #01944d; display: flex; align-items: center; justify-content: center; color: white; border-radius: 4px; cursor: pointer; font-size: 12px;"
                  >
                    点击上传
                  </div>
                </el-upload>
              </el-form-item>
              
              <el-row>
                <div class="form-actions">
                  <el-button type="primary" @click="submitSuggestion">提交</el-button>
                </div>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import DemandForm from "@/components/DemandForm.vue";

export default {
  name: "Feedback",
  components: {
    DemandForm
  },
  data() {
    return {
      activeTab: "demand", // 默认显示新需求发布
      // 需求表单数据，添加 dem_type 字段
      demandFormData: {
        oecode: "",
        goods_name: "",
        vehicletype: "",
        dem_num: "",
        parts_cri: "",
        dem_type: 1 // 1:需求
      },
      // 建议反馈表单数据
      suggestionForm: {
        parts_cri: "",
        dem_type: 2, // 2:建议
        img_name: "", // 图片URL
        fullname: "" // 文件名
      },
      // 上传文件列表
      fileList: [],
      imgList: []
    };
  },
  methods: {
    // 切换标签页
    handleTabClick(tab) {
      this.activeTab = tab.name;
    },
    // 需求表单提交成功回调
    onSubmitSuccess(res) {
      this.$message.success("需求提交成功");
      // 可以在这里添加其他逻辑，比如跳转页面等
    },
    
    // 图片上传成功回调
    upImgSuccess(res) {
      console.log("图片上传成功", res);
      this.imgList.push(res.data);
      // 将图片URL保存到表单数据中
      this.suggestionForm.img_name = this.imgList.map(item => item.url).join(",");
    },
    
    // 文件上传成功回调
    upFileSuccess(res, file) {
      console.log("文件上传成功", res, file);
      this.fileList.push({
        ...res.data,
        fileUrl: res.data.url,
        fileName: file.name
      });
      // 将文件URL保存到表单数据中（使用URL而不是文件名）
      this.suggestionForm.fullname = this.fileList.map(item => item.fileUrl).join(",");
    },
    
    // 文件删除回调
    fileDel(file, type = "imgList") {
      console.log("删除文件", file);
      this[type] = this[type].filter(item => item.url != file.response.data.url);
      
      // 更新表单数据
      if (type === "imgList") {
        this.suggestionForm.img_name = this.imgList.map(item => item.url).join(",");
      } else if (type === "fileList") {
        this.suggestionForm.fullname = this.fileList.map(item => item.fileName).join(",");
      }
      
      console.log("更新后的文件列表", this[type]);
    },
    
    // 提交建议反馈
    async submitSuggestion() {
      try {
        const res = await this.$api.pubDemand({
          store_id: this.$store.state.store_id,
          store_name: this.$store.state.store_name,
          member_id: this.$store.state.member_id,
          member_name: this.$store.state.member_name,
          parts_cri: this.suggestionForm.parts_cri,
          dem_type: this.suggestionForm.dem_type,
          img_name: this.suggestionForm.img_name, // 图片URL
          fullname: this.suggestionForm.fullname // 文件名
        });
        
        if(res) {
          this.$message.success("建议提交成功");
          // 重置表单
          this.suggestionForm.parts_cri = "";
          this.suggestionForm.img_name = "";
          this.suggestionForm.fullname = "";
          this.imgList = [];
          this.fileList = [];
          // 可以在这里添加其他逻辑，比如跳转页面等
          this.$router.push("/my/demand");
        } else {
          this.$message.error("建议提交失败");
        } 
      } catch (error) {
        this.$message.error("提交过程中出现错误");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback-container {
//   padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  
  .feedback-header {
    text-align: center;
    margin-bottom: 30px;
    
    h1 {
      color: #333;
      font-size: 28px;
      margin-bottom: 10px;
    }
  }
  
  .tab-container {
    background: #fff;
    border-radius: 8px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding:5px 10px;
    
    ::v-deep .el-tabs__item {
      font-size: 16px;
      font-weight: 500;
    }
    
    .suggestion-form-container {
      padding: 20px;
      
      .form-header {
        display: flex;
        align-items: center;
        text-align: left;
        margin-bottom: 10px;
        padding-left: 5px;
        border-left: 3px solid #409EFF;
        
        h2 {
          color: #333;
          font-size: 24px;
          margin-bottom: 0;
          white-space: nowrap;
        }
        
        p {
          // color: #999;
          font-size: 22px;
          padding-left: 5px;
          margin: 0;
          flex: 1;
        }
      }
      
      .suggestion-form {
        margin-top: 20px;
        
        .el-form-item {
          margin-bottom: 10px;
          
          ::v-deep .el-form-item__label {
            color: #333;
            font-weight: 500;
          }
          
          ::v-deep .el-input__inner, 
          ::v-deep .el-textarea__inner {
            border: none;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
          
        }
        ::v-deep .custom-textarea .el-textarea__inner {
          border: none;
          background-color: #f5f5f5;
          border-radius: 4px;
        }
        
        .form-actions {
          text-align: center;
          margin-top: 20px;
          
          .el-button {
            padding: 12px 40px;
            font-size: 16px;
            border-radius: 20px;
          }
          
          .el-button--primary {
            background-color: #01944d;
            border-color: #01944d;
          }
        }
      }
    }
  }
  
  // 添加highlight类的样式
  .highlight {
    font-weight: bold;
    color: #063376;
  }
}
</style>